export default class ShopDropdown extends HTMLElement {
  open: boolean = false
  dropdownEl: HTMLElement | null = null
  triggerEl: HTMLElement | null = null
  iconEl: HTMLElement | null = null

  static get observedAttributes() {
    return ['open']
  }

  constructor() {
    super()

    this.dropdownEl = this.querySelector<HTMLElement>('[data-dropdown]')
    this.triggerEl = this.querySelector<HTMLElement>('[data-dropdown-trigger]')
    this.iconEl = this.querySelector<HTMLElement>('[data-dropdown-icon]')

    if (this.triggerEl) {
      this.triggerEl.addEventListener('click', this.handleClick.bind(this))
    }

    // strip out the wrapper div container tag from the content
    const content = this.dropdownEl?.innerHTML

    if (content && this.dropdownEl) {
      this.dropdownEl.innerHTML = content?.replace(/<div[^>]*>/g, '') || ''
    }
  }

  connectedCallback() {
    console.log('Dropdown added')
  }

  get isOpen() {
    return this.open
  }

  set isOpen(value: boolean) {
    this.open = value
    this.setAttribute('open', value.toString())
    this.toggle()
  }

  handleClick(evt: Event) {
    evt.preventDefault()
    this.isOpen = !this.isOpen
  }

  toggle() {
    if (this.isOpen) {
      this.dropdownEl?.classList.remove('hidden')
      this.dropdownEl?.classList.add('block')
      this.iconEl?.classList.add('rotate-180')
    } else {
      this.dropdownEl?.classList.add('hidden')
      this.dropdownEl?.classList.remove('block')
      this.iconEl?.classList.remove('rotate-180')
    }
  }
}

customElements.define('shop-dropdown', ShopDropdown)
